import React from 'react';
import { motion } from 'framer-motion';
import { LuStar } from 'react-icons/lu';
import COUNTRIES from '../../configs/countries';
import Hero1 from '../../assets/hero1.png';
import Hero2 from '../../assets/hero2.png';
import Dashboard from '../../assets/dashboard.png';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.15 } }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const CountrySelectPage = ({ setCountry }) => {
  const handleSelect = (code, available) => {
    if (!available) return;
    try { localStorage.setItem('yros_country', code); } catch (e) {}
    setCountry(code);
  };

  return (
    <main className="min-h-screen overflow-hidden bg-gradient-to-br from-orange-50 via-white to-orange-50 flex items-center">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-orange-200/20 to-yellow-200/20 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-blue-200/20 to-purple-200/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-6 py-16">
        <motion.div initial="hidden" animate="visible" variants={containerVariants} className="text-center">
          <motion.img src={Hero1} alt="décor" className="w-12 h-12 absolute left-6 top-6 md:left-12 md:top-12" animate={{ y: [0, -8, 0] }} transition={{ duration: 8, repeat: Infinity }} />
          <motion.img src={Hero2} alt="décor" className="w-16 h-16 absolute right-6 top-28 md:right-12 md:top-36" animate={{ y: [0, 12, 0] }} transition={{ duration: 8, repeat: Infinity, delay: 1 }} />

          <motion.div variants={itemVariants} className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm border border-orange-200/50 rounded-full px-4 py-2 mb-6 shadow-lg">
            <LuStar className="w-4 h-4 text-orange-500" />
            <span className="text-sm font-medium text-gray-700">Logiciel de paie 100% digital</span>
          </motion.div>

          <motion.h1 variants={itemVariants} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-4">
            Gérez votre paie en{" "}
            <span className="bg-gradient-to-r from-orange-500 to-yellow-500 bg-clip-text text-transparent">
                toute sérénité
            </span>
          </motion.h1>

          <motion.p variants={itemVariants} className="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
            Fini les calculs manuels : génération de bulletins en un clic, 
              mises à jour légales automatiques et suivi en temps réel.
          </motion.p>

          <motion.h3 variants={itemVariants} className="text-xl font-medium mb-6">Choisissez un pays</motion.h3>

          <motion.div variants={itemVariants} className="flex flex-wrap gap-4 justify-center mb-8">
            {COUNTRIES.map((c) => (
              c.available ? (
                <button
                  key={c.code}
                  onClick={() => handleSelect(c.code, c.available)}
                  className="flex items-center gap-4 px-6 py-3 rounded-full bg-white border border-gray-200 shadow-sm hover:shadow-md transition-all"
                  type="button"
                >
                  <span className="text-2xl">{c.flag}</span>
                  <div className="text-left">
                    <div className="font-semibold">{c.name}</div>
                    <div className="text-xs text-gray-500">Disponible</div>
                  </div>
                </button>
              ) : (
                <div key={c.code} className="flex items-center gap-4 px-6 py-3 rounded-full bg-gray-50 border border-gray-100 shadow-sm opacity-60 cursor-not-allowed">
                  <span className="text-2xl">{c.flag}</span>
                  <div className="text-left">
                    <div className="font-medium">{c.name}</div>
                    <div className="text-xs text-yellow-700">En développement</div>
                  </div>
                </div>
              )
            ))}
          </motion.div>

          <motion.div variants={itemVariants} className="relative max-w-4xl mx-auto">
            <div className="absolute inset-0 bg-gradient-to-r from-orange-500/20 to-yellow-500/20 rounded-[2rem] blur-2xl transform scale-105"></div>
            <img src={Dashboard} alt="aperçu" className="relative w-full border-8 border-white rounded-[1.5rem] shadow-2xl" />
          </motion.div>

          <motion.div variants={itemVariants} className="mt-6 text-sm text-gray-500">Vous pouvez changer le pays plus tard via le sélecteur en haut à droite.</motion.div>
        </motion.div>
      </div>
    </main>
  );
};

export default CountrySelectPage;
